import React, { useEffect, useState } from 'react'
import { ProtectedPage } from '~/src/components/templates'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useLocation, Navigate } from 'react-router-dom'
import { LoadingNormal } from '~/src/components/organisms/Loading/LoadingNormal'
import { OrderStatementOfAccountDetailForm } from '~/src/components/organisms/StatementOfAccount/StatementOfAccountDetail/OrderStatementDetailForm'
import { IStatementDetailParams } from '~/src/repositories/Order/models/Order'

export const OrderStatementOfAccountDetail: React.VFC = (): JSX.Element => {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()

  const [isLoading, setIsLoading] = useState<boolean>(true)

  const id = searchParams.get('id')
  const location = useLocation()
  // @ts-ignore
  const statement = location.state.item as IStatementDetailParams | null

  // @ts-ignore
  useEffect(() => {
    if (!id || !statement) {
      // 直リンクの場合はデータがないのでリストに戻す
      return <Navigate to="/admin/order/statement-of-account/list" />
    }
    setIsLoading(false)
  }, [id])

  if (isLoading) return <LoadingNormal />

  return (
    <ProtectedPage pageTitle={t('statement_account_detail.title')}>
      {/*@ts-ignore*/}
      <OrderStatementOfAccountDetailForm id={id} user={statement} />
    </ProtectedPage>
  )
}
